import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useImperativeHandle, useRef, useState } from "react";
import { stringToParsedTokenArray } from "@poscon/shared-types/eram";
import { CLEAR_WEATHER_SYMBOL } from "@poscon/shared-types";
import { useDispatch } from "react-redux";
import { eramFontDimensionMap, eramFontNameMap, getBitmapTextStyles } from "../../eramFont.js";
import { colorNameMap } from "../../colorNameMap.js";
import { setSelectedAdvisory } from "../slices/commonSlice.js";
import { EramPrompt } from "./EramPrompt.js";
import { useCenterCursor } from "../hooks/useCenterCursor.js";
import { EramInput, useInputProps } from "./EramInput.js";
import { MenuElement } from "./MenuElement.js";
export const advFreetextTemplateView = "ADV_FREETEXT_TEMPLATE";
const fontFamily = eramFontNameMap[2];
const fontDim = eramFontDimensionMap[fontFamily];
export const advFreetextWidth = 46 * fontDim.width;
const freetextInputHeight = fontDim.height * 5 + 4;
const flidInputHeight = fontDim.height * 2 + 4;
const height = freetextInputHeight + fontDim.height + 4 + flidInputHeight + 12;
export const AdvFreetextTemplate = ({ dispatchCommand, ref, ...promptProps }) => {
    const localRef = useRef(null);
    const dispatch = useDispatch();
    const [uplinkSelected, setUplinkSelected] = useState(false);
    const freetextInputProps = useInputProps(`${advFreetextTemplateView}/text`, "", undefined, {
        focusOnMount: true,
        pasteOnTBE: true,
    });
    const flidInputProps = useInputProps(`${advFreetextTemplateView}/flid`, "", (s) => {
        dispatchCommand(stringToParsedTokenArray(`UM /F ${freetextInputProps.value}${CLEAR_WEATHER_SYMBOL} ${s}`));
        dispatch(setSelectedAdvisory(null));
    }, { focusOnMount: false });
    useCenterCursor(localRef);
    useImperativeHandle(ref, () => {
        return localRef.current;
    }, []);
    return (_jsxs(EramPrompt, { ref: localRef, title: "FREETEXT TEMPLATE", width: advFreetextWidth, height: height, closeMenu: () => {
            dispatch(setSelectedAdvisory(null));
        }, showX: true, ...promptProps, children: [_jsx("bitmapText", { x: 4, y: 3, text: "FREETEXT", style: { ...getBitmapTextStyles(fontFamily), fill: colorNameMap.lightGrey } }), _jsx(EramInput, { x: fontDim.width * 8 + 12, y: 3, width: fontDim.width * 35 + 4, height: fontDim.height * 5 + 4, chunkSize: 35, borderTint: colorNameMap.grey, highlightColor: colorNameMap.white, ...freetextInputProps }), _jsx(MenuElement, { x: (advFreetextWidth - fontDim.width * 6 - 2) / 2, y: fontDim.height * 5 + 10, text: "UPLINK", selected: uplinkSelected, onmousedown: () => setUplinkSelected((prev) => !prev) }), uplinkSelected && (_jsxs("container", { y: fontDim.height * 6 + 14, children: [_jsx("bitmapText", { x: 4, y: 3, text: "FLID", style: { ...getBitmapTextStyles(fontFamily), fill: colorNameMap.lightGrey } }), _jsx(EramInput, { x: fontDim.width * 8 + 12, y: 3, width: fontDim.width * 35 + 4, chunkSize: 35, height: fontDim.height * 2 + 4, borderTint: colorNameMap.grey, highlightColor: colorNameMap.white, ...flidInputProps })] }))] }));
};
//# sourceMappingURL=AdvFreetextTemplate.js.map